import { render, staticRenderFns } from "./HRConfig.vue?vue&type=template&id=15971af0&scoped=true"
import script from "./HRConfig.vue?vue&type=script&lang=js"
export * from "./HRConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15971af0",
  null
  
)

export default component.exports